<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <router-link to="/" class="logo">
          <img v-if="companyInfo.logoUrl" :src="companyInfo.logoUrl" alt="卓亿餐饮">
          <span v-else>卓亿餐饮</span>
        </router-link>
        <nav class="nav">
          <router-link to="/">首页</router-link>
          <router-link to="/about">品牌介绍</router-link>
          <router-link to="/menu">特色服务</router-link>
          <router-link to="/stores">合作伙伴</router-link>
          <router-link to="/join">加盟招商</router-link>
          <router-link to="/message">在线留言</router-link>
          <router-link to="/contact">联系我们</router-link>
        </nav>
        <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <div class="mobile-menu" :class="{ active: showMobileMenu }">
      <router-link @click.native="showMobileMenu = false" to="/">首页</router-link>
      <router-link @click.native="showMobileMenu = false" to="/about">品牌介绍</router-link>
      <router-link @click.native="showMobileMenu = false" to="/menu">特色服务</router-link>
      <router-link @click.native="showMobileMenu = false" to="/stores">合作伙伴</router-link>
      <router-link @click.native="showMobileMenu = false" to="/join">加盟招商</router-link>
      <router-link @click.native="showMobileMenu = false" to="/message">在线留言</router-link>
      <router-link @click.native="showMobileMenu = false" to="/contact">联系我们</router-link>
    </div>
  </header>
</template>

<script>
import { getCompanyInfo } from '@/api/company'

export default {
  name: 'Header',
  data() {
    return {
      showMobileMenu: false,
      companyInfo: {}
    }
  },
  mounted() {
    this.loadCompanyInfo()
  },
  methods: {
    async loadCompanyInfo() {
      try {
        const res = await getCompanyInfo()
        this.companyInfo = res.data || {}
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
  .header {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }

  .logo {
    font-size: 24px;
    font-weight: bold;
    color: #4CAF50;
    text-decoration: none;
    display: flex;
    background: #ffffff; /* 关键：容器背景为纯白 */
    align-items: center;
  }

  .logo img {
    height: 70px;
    margin-right: 10px;
    vertical-align: middle; /* 防止底部多出空白 */
  }

  .nav {
    display: flex;
    gap: 30px;
  }

  /* 原来的 nav a 样式 */
  .nav a,
  .mobile-menu a {
    text-decoration: none;
    color: #333;
    font-size: 16px;
    transition: color 0.3s;
  }

  /* ✅ 修改为精确匹配 */
  .nav a.router-link-exact-active,
  .mobile-menu a.router-link-exact-active {
    color: #4CAF50;
  }

  /* 悬停效果 */
  .nav a:hover {
    color: #4CAF50;
  }

  .mobile-menu-btn {
    display: none;
    font-size: 24px;
    cursor: pointer;
  }

  .mobile-menu {
    display: none;
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }

  .mobile-menu a.router-link-exact-active {
    color: #4CAF50;
  }

  .mobile-menu a {
    display: block;
    padding: 15px 0;
    text-decoration: none;
    color: #333;
    border-bottom: 1px solid #eee;
  }

  @media (max-width: 768px) {
    .nav {
      display: none;
    }

    .mobile-menu-btn {
      display: block;
    }

    .mobile-menu.active {
      display: block;
    }
  }
</style>
